// ES6 Polyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import sal from 'sal.js';

// Lazyloading
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';

import contentDropdown from './modules/contentDropdown';
import header from './modules/header';
import map from './modules/map';
import sidebarNavigation from './modules/sidebarNavigation';
import sliderTeaser from './modules/sliderTeaser';
import countdown from './modules/countdown';
import printImage from './modules/printImage';
import share from './modules/share';
import overlay from './modules/overlay';
import tabNavigation from './modules/tabNavigation';
import sliderTabNavigation from './modules/sliderTabNavigation';
import sliderTestimonials from './modules/sliderTestimonials';
import elementStateToggle from './modules/elementStateToggle';
import newsTicker from '../../../../../src/js/modules/newsTicker';
import videoLoader from '../../../../../src/js/modules/videoLoader';
import frcCaptcha from '../../../../../src/js/modules/frcCaptcha';

window.addEventListener('load', () => {
    sal();

    sidebarNavigation.init();
    contentDropdown.init();
    header.init();
    map.init();
    sliderTeaser.init();
    countdown.init();
    printImage.init();
    share.init();
    overlay.init();
    tabNavigation.init();
    sliderTabNavigation.init();
    sliderTestimonials.init();
    newsTicker.init();
    videoLoader.init();
    elementStateToggle.init({
        preventDefault: true,
        hasContextElement: {
            elements: '.js-state-context',
            attr: 'href',
        },
        toggleActiveElement: true,
    });
    /**
     * Accordion Component
     */
    elementStateToggle.init({
        triggerElementSelector: '.js-accordion-header',
        toggleActiveElement: true,
        removeAllActiveClasses: false,
    });
    frcCaptcha();
});
